export class AuditoriaBeanM {

    b_aud: String;
	c_aud_uid: String;
	c_aud_uidred : String;
	c_aud_pc : String;
	n_aud_ip : String;
	n_aud_mcaddr: String;
        
}